/** Authorization fixtures
 *
 */
export * from './confidentialityAgreement'
